import { clientLocalDate } from './clientContext'
import { briefingKeyMorning, isBriefingRead } from './coachBriefingReadState'
import type { CoachHealthSummary } from './coachHealthTypes'
import type { TodayProtocolResponse } from './dailyOverrideTypes'

export type MorningFlowStep = 'check_in' | 'briefing'

export function hasWearableBiometricsToday(summary: CoachHealthSummary | null): boolean {
  if (!summary?.has_device_connected || !summary.has_metric_data) return false
  const today = summary.today
  const hasHrv = today.hrv_rmssd != null || today.hrv != null
  const hasRhr = today.resting_heart_rate != null
  const hasSleep = today.sleep_duration_minutes != null
  return Boolean(hasHrv || hasRhr || hasSleep)
}

export function isMorningCheckInComplete(protocol: TodayProtocolResponse | null): boolean {
  return protocol?.subjective_stress_score != null
}

export function isMorningBriefingComplete(
  hasWearable: boolean,
  showMorningBrief: boolean,
  hasMorningText: boolean,
): boolean {
  const markedRead = isBriefingRead(briefingKeyMorning(clientLocalDate()))

  if (!hasWearable) {
    return markedRead
  }

  if (!showMorningBrief || !hasMorningText) {
    return true
  }

  return markedRead
}

export function requiresExplicitBriefingStep(hasWearable: boolean): boolean {
  return !hasWearable
}

export function morningFlowSequence(hasWearable: boolean): MorningFlowStep[] {
  return hasWearable ? ['briefing', 'check_in'] : ['check_in', 'briefing']
}

export function resolveActiveMorningStep(
  sequence: MorningFlowStep[],
  checkInComplete: boolean,
  briefingComplete: boolean,
): MorningFlowStep | null {
  for (const step of sequence) {
    if (step === 'check_in' && !checkInComplete) return 'check_in'
    if (step === 'briefing' && !briefingComplete) return 'briefing'
  }
  return null
}

export function isMorningFlowComplete(checkInComplete: boolean, briefingComplete: boolean): boolean {
  return checkInComplete && briefingComplete
}
